  import Vue from 'vue'
import VueRouter from 'vue-router'
import { Trans } from './plugins/Translation'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

let routes_ = [
  { 
    path: '*', 
  }, 
  {
    path: '/',
    name: 'home',
    component: () => import('./views/Home.vue') , 
    children : [  
    ]
  }, 
  {
    path: '/about',
    name: 'about',
    component: () => import('./views/AboutIARC.vue') , 
    meta: { breadcrumb: [ { name: 'about' } ] }
  }, 
  {
    path: '/database',
    name: 'database',
    component: () => import('./views/Database.vue') , 
    meta: { breadcrumb: [ { name: 'database' } ] }
  }, 
  {
    path: '/dataviz',
    name: 'dataviz',
    component: () => import('./views/Dataviz.vue') , 
    meta: { breadcrumb: [ { name: 'dataviz' } ] } 
  }, 
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./views/Dataviz/Dashboard.vue') , 
    meta: { breadcrumb: [ { name: 'dashboard' } ] } 
  }, 
  {
    path: '/dashboard_new',
    name: 'dashboard_new',
    component: () => import('./views/Dataviz/DashboardNew.vue') , 
    meta: { breadcrumb: [ { name: 'dashboard_new' } ] } 
  }, 
  {
    path: '/references',
    name: 'references',
    component: () => import('./views/Help.vue') , 
    meta: { breadcrumb: [ { name: 'references' } ] } 
  }, 
  {
    path: '/country_briefs',
    name: 'country_briefs',
    component: () => import('./views/Factsheets.vue') 
  }, 
  {
    path: '/factsheet/:name',
    name: 'factsheet',
    component: () => import('./views/Factsheet.vue') , 
  },
  { 
    path: '/hello', 
    name: 'hello',
    component: () => import('@/csu-vue-components/test/Hello.vue')
  }, 
  {
    path: '/trends',
    name: 'trends',
    component: () => import('./views/Dataviz/Trends.vue') , 
    props: true  
  }, 
  {
    path: '/trends-scenario-3',
    name: 'trends_scenario_3',
    component: () => import('./views/Dataviz/Trends.vue') , 
    props: true 
  }, 
  {
    path: '/bars',
    name: 'bars',
    component: () => import('./views/Dataviz/SimpleBars.vue') , 
  }, 
  {
    path: '/bars-scenario-3',
    name: 'bars_scenario_3',
    component: () => import('./views/Dataviz/SimpleBars.vue') , 
  },
  {
    path: '/stacked-bars', 
    name: 'stacked_bars',
    component: () => import('./views/Dataviz/StackedBars.vue')
  },
  {
    path: '/under_development', 
    name: 'under_development',
    component: () => import('./views/UnderDev.vue')
  }
]

if ( process.env.VUE_APP_MAINTENANCE == 1) {
  routes_.map( r => {
    if ( r.name != 'under_development'){
      r.component = () => import('./views/UnderDev.vue') ; 
    }
    return r ; 
  })
}

const Router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL ,
  beforeEnter: Trans.routeMiddleware,
  routes : routes_ ,
  scrollBehavior(to, from, savedPosition) {
    // `to` and `from` are both route objects
    // console.info("scrollBehavior",to,from,savedPosition)
    if ( to.hash ) {
      return { selector: to.hash }
    }
    else
      return { x: 0, y: 0 }
  }
})

Router.afterEach((to,from,next) => {

  // console.info("to",to.name,process.env.VUE_APP_MAINTENANCE);

  /*if ( to.name != 'under_development' && process.env.VUE_APP_MAINTENANCE == 1) 
  {
    document.location.href = '/covid/under_development'
  }*/

  if ( to.name != 'home')
  {
    // console.log("change router",to.name,
    setTimeout(() => {
      $('.header-menu-links .menu-item:first-child a').removeClass('router-link-active') ;
    }, 250 )   
  }

  let routing = to.path.split('/');
  delete routing[0] ; delete routing[1] ; 
  routing.filter(()=>{ return true })

  document.querySelector('html').className = routing.join(' ').trim(); 
}); 

export default Router ; 